module.exports = __webpack_public_path__ + "img/kcjt-name-img.dd59d5b7.png";